import React from 'react';
import styles from './client.module.scss';


class Client extends React.Component {
  render () {
    return (
      <div id={this.props.id} className={this.props.featured ? styles.client : styles.featuredClient}>
        <div className={styles.row}>
          <div className="col-half">
            {this.props.featured && <h2 className={styles.title}>Featured Client</h2>}
            {this.props.name && <h3>{this.props.name}</h3>}
            {this.props.children}
          </div>
          <div className="col-half"><img src={this.props.image} alt="CustomFit Featured Client"/></div>
        </div>
      </div>
    )
  }
}

export default Client;


// WEBPACK FOOTER //
// ./src/components/Client/index.js